module.exports = "<p>\r\n  rules works!\r\n</p>\r\n"